// src/components/class/ClassAccordion.tsx

import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import {
  ArrowCircleLeftOutlined,
  ArrowCircleRightOutlined,
} from "@mui/icons-material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Class } from "@shared/types";
import StudentsTable from "../tables/StudentsTable";
import ClassCodePanel from "../teacher/ClassCodePanel";

interface ClassAccordionProps {
  schoolID: number;
  classItem: Class;
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  isOnlyAccordion?: boolean;
}

const ClassAccordion = observer(({ classItem, ...props }: ClassAccordionProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Accordion
      data-class-id={classItem.id}
      expanded={props.expanded}
      onChange={props.onChange}
      TransitionProps={{ timeout: { enter: 600, exit: 800 } }}
    >
      <AccordionSummary
        expandIcon={
          i18n.language === "en" ? (
            <ArrowCircleRightOutlined />
          ) : (
            <ArrowCircleLeftOutlined />
          )
        }
      >
        <div className="headers">
          <h3>{classItem.name.toLowerCase().includes(t("class").toLowerCase()) ? classItem.name : t("class") + " " + classItem.name}</h3>
          <p className="student-count" style={{ marginTop: -4, fontSize: 12, fontWeight: 300 }}>
            ({classItem.students.length} {t("students")})
          </p>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <ClassCodePanel gradeId={classItem.id} />
        <StudentsTable classItem={classItem} />
      </AccordionDetails>
    </Accordion>
  );
});

export default ClassAccordion;
